import '@calcom/atoms/globals.min.css';
import { Drawer } from '@mantine/core';
import { useGlobalStore } from '../../store/useGlobalStore';
import { styled, useTheme } from '../../theme/theme';
import { CalendarView } from './CalendarView';
import { CalendarHeader } from './CalendarHeader';

export const CalendarDrawer = () => {
  const theme = useTheme();
  const calendarDrawerOpen = useGlobalStore((store) => store.settings.calendarDrawerOpen);
  const setCalendarDrawerOpen = useGlobalStore((store) => store.settings.setCalendarDrawerOpen);

  return (
    <Root>
      <Drawer
        position='right'
        opened={calendarDrawerOpen}
        onClose={() => setCalendarDrawerOpen(false)}
        size={theme.screen.width.px < 769 ? '100vw' : '75vw'}
        styles={{
          header: {
            zIndex: 999999,
            backgroundColor: 'transparent',
          },
          body: {
            overflowX: 'hidden',
          },
          content: {
            overflowX: 'hidden',
          },
        }}
      >
        <Content>
          <CalendarHeader />
          <CalendarViewWrapper>
            <CalendarView />
          </CalendarViewWrapper>
        </Content>
      </Drawer>
    </Root>
  );
};

const Root = styled.div`
  .mantine-Drawer-header {
    z-index: 99999 !important;
    height: 48px;
    display: flex;
    align-items: center;
    background-color: transparent !important;
  }
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 16px;

  @media (min-width: 769px) {
    padding: 0 32px;
  }
`;

const CalendarViewWrapper = styled.div`
  margin-top: 24px;

  @media (min-width: 769px) {
    margin-top: 48px;
  }
`;
